import { ReactElement, useRef, useState } from 'react';
import style from './index.module.scss';
import { Color } from '../../../styles/typescript/types/color';
import Typography from '../../Typography';

const Adornment = ({
  children,
  ...props
}: {
  children?: JSX.Element;
  onClick?: () => void;
}): ReactElement => {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };
  return <span style={{ cursor: 'pointer' }} onClick={handleClick}>{children}</span>;
};

const TextField = (props: {
  onChange?: (e: any) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  label?: string;
  type?: string;
  placeholder?: string;
  maxLength?: number;
  value?: string;
  helperText?: string;
  startAdornment?: JSX.Element;
  endAdornment?: JSX.Element;
  onEndAdornment?: () => void;
  helperTextColor?: Color;
  isError?;
  id?: string;
}): ReactElement => {
  const [state, setState] = useState({
    focus: false,
  });
  const inputRef = useRef(null)

  const handleChange = (e: any) => {
    if (props.onChange) {
      props.onChange(e);
    }
  };

  const handleFocus = () => {
    setState({ ...state, focus: true });
    if (props.onFocus) {
      props.onFocus();
    }
  };

  const handleBlur = () => {
    setState({ ...state, focus: false });
    if (props.onBlur) {
      props.onBlur();
    }
  };

  const handleEndAdornment = () => {
    if (props.onEndAdornment) {
      props.onEndAdornment();
    }
  };

  return (
    <div className={style['container']}>
      <div className={style['text-wrapper']}>
        <Typography variant="body-3-semibold" color="dark40">
          {props.label}
        </Typography>
      </div>
      <div
        className={`${style['box-input']}` + ' ' + (() => {
            if (props?.isError)
              return style['box-input--error']
            if (state.focus)
              return style['box-input--focus']
            return ''
          })()
        }
        onClick={() => inputRef.current.focus()}
      >
        {props.startAdornment}
        <input
          ref={inputRef}
          className={style.input}
          id={props?.id}
          type={props.type}
          onChange={(e: any) => handleChange(e)}
          onFocus={() => handleFocus()}
          onBlur={() => handleBlur()}
          placeholder={props.placeholder}
          maxLength={props.maxLength}
          value={props.value}
        />
        {props.endAdornment && (
          <Adornment onClick={handleEndAdornment}>
            {props.endAdornment}
          </Adornment>
        )}
      </div>

      <div className={style['text-wrapper']}>
        <Typography variant="caption-1-medium" color={props.helperTextColor}>
          {props.helperText}
        </Typography>
      </div>
    </div>
  );
};

TextField.defaultProps = {
  label: '',
  type: 'text',
  placeholder: '',
  maxLength: 30,
  value: '',
  helperText: '',
  helperTextColor: 'white',
  isError: false,
};

export default TextField;
